module.exports = __webpack_public_path__ + "static/media/Mereoleona-Script-Alt.cf147fc3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mereoleona-Script-Alt.ttf
// module id = 2333
// module chunks = 49